// @flow
import RegisterPaymentDetails from './RegisterPaymentDetails';
import { connect } from 'react-redux';
import { isLoadingSelector } from '../../../modules/LoadingStatus/reducer';
import { refreshPaymentDetailsDuringActivate } from '../../../modules/Payment';

const mapStateToProps = state => ({
  isLoading:
    isLoadingSelector(state, 'refreshPaymentDetails') || isLoadingSelector(state, 'updateBillingAddressDuringProcess'),
  isActivating: true,
});

const mapDispatchToProps = {
  refreshPaymentDetails: refreshPaymentDetailsDuringActivate,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterPaymentDetails);
